import { trackerDelete, trackerGet, trackerPatch, trackerPost } from '../client';
import type { GroupCreate, GroupUpdate, PageResult, TrackerGroup } from '../types';

export function listDomainGroups(params: { page?: number; page_size?: number } = {}) {
  return trackerGet<PageResult<TrackerGroup>>('/domain-groups', params);
}

export function createDomainGroup(body: GroupCreate) {
  return trackerPost<TrackerGroup>('/domain-groups', body);
}

export function updateDomainGroup(id: number, body: GroupUpdate) {
  return trackerPatch<TrackerGroup>(`/domain-groups/${id}`, body);
}

export function deleteDomainGroup(id: number) {
  return trackerDelete(`/domain-groups/${id}`);
}
